import { onCtxAbort, reaction } from '@reatom/framework'

import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { dependenciesAtom } from '@root/features/shared/dependencies'

export const initializeOrdersSocketAction = reaction((ctx) => {
  const { mainWebsocket } = ctx.get(dependenciesAtom)

  const delugeId = ctx.spy(delugeIdAtom)
  if (!delugeId) {
    return
  }
  const network = ctx.spy(selectedNetworkAtom)
  mainWebsocket.userOrderSubscribeAction(ctx, { delugeId, network })
  onCtxAbort(ctx, () => {
    mainWebsocket.userOrderUnsubscribeAction(ctx, { network, delugeId })
  })
}, 'initializeOrdersSocketAction')
